"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductDetails = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ProductDetails = ({
  currentShade,
  productCode,
  bonusPoints,
  className,
  isMultiShade,
  size
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const details = [productCode, size, bonusPoints].filter(Boolean);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Details, {
    className: className,
    "data-testid": getTestId(_constants.PRODUCT_DETAILS),
    variant: "caption",
    component: "p",
    children: [isMultiShade ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CustomShade, {
        shade: {
          ...currentShade,
          canBeSold: true
        },
        testId: getTestId(_constants.PRODUCT_DETAILS_MINI_SHADE),
        size: _presentationComponents.ShadeSize.Inline
      }), currentShade.name, details.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Divider, {}) : null]
    }) : null, details.map((detail, index) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
      children: [detail, index < details.length - 1 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Divider, {}) : null]
    }, detail))]
  });
};
exports.ProductDetails = ProductDetails;
